import React from 'react';
import styled, { css } from 'styled-components';
import { Flex, Text, mediaQueries } from 'pcln-design-system';
import { TierBadge, VipIcon } from '@pcln/vip';
import Banner from '../Banner';
const IconContainer = styled(Flex) `
  ${(props) => `align-self: ${props.mobileIconAlignSelf};`}
  ${mediaQueries.md} {
    align-self: center;
  }
`;
const ResponsiveVipIcon = styled(VipIcon) `
  display: flex;
  ${(props) => props.fontSizeCss}
`;
/** @public */
const VipBanner = ({ bgColor = 'primary.light', borderHugLeft, borderHugTop, borderRadius, boxShadowSize, buttonRight, buttonRightBreakPoint = 'md', heading, hoverBoxShadowSize, iconContainerProps, iconRight, iconSizeCss, imageLeft, includeIconText, isButtonFullWidthAtBreakPoint, isDark, justifyContent, mobileIconAlign, px, py, text, vipTier, }) => {
    let mobileIconAlignSelf = mobileIconAlign ?? 'flex-start';
    let fontSizeCss = iconSizeCss ??
        css `
      font-size: 28px;
      ${mediaQueries.md} {
        font-size: 48px;
      }
    `;
    if (includeIconText) {
        mobileIconAlignSelf = 'center';
        fontSizeCss = css `
      font-size: 36px;
    `;
    }
    const vipIconLeft = vipTier && includeIconText ? (React.createElement(IconContainer, { mobileIconAlignSelf: mobileIconAlignSelf, ...iconContainerProps },
        React.createElement(TierBadge, { "data-testid": 'left icon', layout: 'stacked', level: vipTier, pr: 1, size: 'small' }))) : (React.createElement(IconContainer, { alignItems: 'center', "data-testid": 'left icon', flexDirection: 'column', includeIconText: includeIconText, mobileIconAlignSelf: mobileIconAlignSelf, pr: includeIconText ? 1 : 0, ...iconContainerProps },
        React.createElement(ResponsiveVipIcon, { fontSizeCss: fontSizeCss, variation: 'vip' }),
        includeIconText && (React.createElement(Text, { color: isDark ? 'text.lightest' : 'primary.dark', fontWeight: 'bold', pt: 2, fontSize: 0 }, "MEMBER"))));
    return (React.createElement(Banner, { bgColor: bgColor, borderHugLeft: borderHugLeft, borderHugTop: borderHugTop, borderRadius: borderRadius, boxShadowSize: boxShadowSize, buttonRight: buttonRight, buttonRightBreakPoint: buttonRight ? buttonRightBreakPoint : undefined, heading: React.createElement(Text, { fontSize: [2, null, 3], pb: 1, pr: iconRight && '25px', color: 'primary.base' }, heading), hoverBoxShadowSize: hoverBoxShadowSize, iconLeft: !iconRight && vipIconLeft, iconRight: iconRight && React.createElement(VipIcon, { "data-testid": 'right icon', fontSize: '25px', variation: 'vip' }), imageLeft: imageLeft, isButtonFullWidthAtBreakPoint: isButtonFullWidthAtBreakPoint, justifyContent: justifyContent, px: px, py: py, text: React.createElement(Text, { fontSize: [0, null, 1], pr: iconRight && '25px' }, text) }));
};
export default VipBanner;
//# sourceMappingURL=VipBanner.js.map